import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { environment as env } from 'src/environments/environment';
import { of, throwError, Observable, BehaviorSubject } from 'rxjs';
import { map, catchError, tap } from 'rxjs/operators';
import { FormGroup } from '@angular/forms';
import { ProduitType } from "../Types/Produit.type";
import { BienType } from "../Types/Bien.type";


@Injectable({
  providedIn: 'root'
})
export class DataService {

  private HOST = env.HOST;
  private HOST_adresses = env.HOST_adresses;


  constructor(private http: HttpClient) { }
  refs: any;

  // BehaviorSubject pour notifier les changements
  private backofficeDataSubject = new BehaviorSubject<any>(null);
  public backofficeData$ = this.backofficeDataSubject.asObservable();

  fr = {
    firstDayOfWeek: 1,
    dayNames: ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"],
    dayNamesMin: ["D", "L", "M", "M", "J", "V", "S"],
    monthNames: ["janvier", "fevrier", "mars", "avril", "mai", "juin", "juillet", "aout", "septembre", "octobre", "novembre", "decembre"],
    dayNamesShort: ["dim", "lun", "mar", "mer", "jeu", "ven", "sam"],
    monthNamesShort: ["jan", "fev", "mar", "avr", "mai", "jun", "jul", "aou", "sep", "oct", "nov", "dec"],
    today: "Aujourd'hui",
    clear: 'Effacer'
  }

  reclamationToRenouvellement: any;
  savedBackofficeData: any

  getCalendarfr() {
    return this.fr;
  }

  getYearByAdresse(res): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const body = { ...res };
    return this.http.post<any>(this.HOST_adresses + "/getYear", body, { headers });
  }

  fix2Dates(form: FormGroup, controlName: string): Promise<any> {
    if (form.get(controlName).value[0] && form.get(controlName).value[1]) {
      let date_debut = form.get(controlName).value[0];
      let date_fin = form.get(controlName).value[1];

      date_debut = new Date(+date_debut - 1000 * 60 * date_debut.getTimezoneOffset());
      date_fin = new Date(+date_fin - 1000 * 60 * date_fin.getTimezoneOffset());
      return Promise.resolve([date_debut, date_fin]);
    }
  }

  getJsonData(lien): Observable<any> {
    return this.http.get<any>(lien);
  }

  getChangelog(offset: number) {
    return this.http.get(this.HOST + '/changelog/' + offset);
  }


  addAccount(obj: any) {
    console.log('add' + obj)
    const accounts = this.deleteAccount(obj.utilisateur_ID);//Doit etre en premier
    accounts.push(obj);
    localStorage.setItem("accounts", JSON.stringify(accounts));
  }

  changeAccount(utilisateur_ID: string | number) {
    console.log('change to' + utilisateur_ID)
    const obj = JSON.parse(localStorage.getItem("accounts") || '[]').find((x: any) => x.utilisateur_ID == utilisateur_ID);
    localStorage.setItem("token", obj.token);
    localStorage.setItem("utilisateur", obj.utilisateur_ID);
    localStorage.setItem("user_type", "1"); //2=agence 1=backoffice
    localStorage.setItem("token_exp", obj.expire);
    localStorage.setItem("mail", obj.mail);
    //Doit rediriger vers /backoffice si necessaire
    this.refs = null;
    window.location.replace('/backoffice');
    //window.location.reload();
  }

  refreshAccount() {
    console.log('refresh')
    const oldObj = {
      token: localStorage.getItem("token"),
      utilisateur_ID: parseInt(localStorage.getItem("utilisateur")),
      expire: localStorage.getItem("token_exp"),
      mail: localStorage.getItem('mail')
    }
    if (oldObj.token && oldObj.utilisateur_ID)
      this.addAccount(oldObj);
  }

  compareArrays(arr1, arr2) {
    const set1 = new Set(arr1);
    const set2 = new Set(arr2);
    if (set1.size !== set2.size) {
      return false;
    }
    for (const item of set1) {
      if (!set2.has(item)) {
        return false;
      }
    }
    return true;
  }

  deleteAccount(utilisateur_ID?: number | string) {
    console.log('delete' + utilisateur_ID);
    utilisateur_ID = utilisateur_ID || localStorage.getItem("utilisateur");
    let accounts = JSON.parse(localStorage.getItem("accounts") || '[]');
    accounts = accounts.filter((x: any) => x.utilisateur_ID != utilisateur_ID);
    localStorage.setItem("accounts", JSON.stringify(accounts));
    return accounts;
  }

  disconnect(all = false) {
    console.log('disconnect' + all)
    this.deleteAccount();
    localStorage.removeItem('token');
    localStorage.removeItem('utilisateur');
    localStorage.removeItem('mail');
    localStorage.removeItem('token_exp');
    this.refs = null;//Important de vider les refs pour eviter une fuite de donnees si connection a un autre bo
    if (all) localStorage.removeItem('accounts');
  }

  handleError(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // server-side error
      console.log(error);

      errorMessage = `Nous avons rencontré un problème technique lors de l'enregistrement du rendez-vous.
      Merci de contacter notre secrétariat.
      Nous nous excusons pour la gêne occasionnée.
      Cordialement,`;
    }
    //alert(errorMessage);
    return throwError(errorMessage);
  }


  getRefs() {
    if (this.refs) {
      console.log('depuis le cache');
      return of(this.refs)
    }
    return this.http.get(this.HOST + '/refs/').pipe(map((res: any) => {
      this.refs = res;
      return res;
    }));
  }

  fileDownload(full_url: string) {
    //Necessite le retrait du header authorisation dans l interceptor (fait)
    return this.http.get(full_url, {
      responseType: 'blob'
    });
  }
  getRefsClient() {
    if (this.refs) return of(this.refs);
    return this.http.get(this.HOST + '/refs/client').pipe(map((res) => { this.refs = res; return res; }));
  }

  //fonction pour les non-admin (les connecté a leur compte client n ont pas besoin de transmettre de backoffice_ID)
  getBackofficeData(backoffice_ID: number = null, mini_token: string = "",mode="",ID=null,technicien_ID=null) {
    if (this.savedBackofficeData) {
      return of(this.savedBackofficeData);
    }

    return this.http.post(this.HOST + '/general/backoffice/get', { backoffice_ID, mini_token,mode,ID,technicien_ID }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }).pipe(
      tap((res: any) => {
        this.savedBackofficeData = res;
        this.backofficeDataSubject.next(res); // Émet vers les subscribers
      })
    );
  }

  /**
   * Facturation électronique activée pour le cabinet : c'est ce qui rend obligatoire le SIRET d'une
   * société facturée. Lu dans les données du cabinet déjà en cache ; faux tant qu'elles ne sont pas chargées.
   */
  get facturationElectroniqueActive(): boolean {
    return !!+this.savedBackofficeData?.backoffice?.facturation_electronique;
  }

  // Recharger après modification des réglages
  reloadBackofficeData() {
    this.savedBackofficeData = null;
    return this.getBackofficeData(0, '', 'admin');
  }

  backofficeData(res, situation: string) {
    console.log('backofficeData', res, situation);
    return this.http.post(this.HOST + '/general/backoffice/gestion-backoffice', { ...res, situation }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  getNoteGestion(categorie_ID, action = "get") {
    return this.http.post(this.HOST + '/general/gestion/note', { categorie_ID, action }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  enregistrerNoteGestion(categorie_ID, note, action = "enregistrer") {
    return this.http.post(this.HOST + '/general/gestion/note', { categorie_ID, note, action }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  SearchPartenaires(recherche: string) {
    return this.http.post(this.HOST + '/recherche/partenaires', { recherche }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }
  SearchProprietaire(recherche: string) {
    return this.http.post(this.HOST + '/recherche/proprietaire', { recherche }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }


  SearchIfVip(facturation_mail: string,backoffice_ID=null) {
    return this.http.post(this.HOST + '/recherche/vip', { facturation_mail,backoffice_ID }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  SearchIfContactConnue(recherche: string) {
    return this.http.post(this.HOST + '/recherche/contact-connu', { recherche }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  postPrixModificationDiagnosticNew(diagnostics_obligatoires: number[], remise: any[], res, credit_utilise?) {
    return this.http.post(this.HOST + '/diagnostics/prix', { diagnostics_obligatoires, ...res }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  postPrixapplicationReduction(prix: number, remise: any, code_promo, remise_compte_client_ID) {
    return this.http.post(this.HOST + '/diagnostics/remise', { prix, remise, code_promo, remise_compte_client_ID }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }


  diagnosticObligatoir(ref_bien: number, copro: boolean, superficie: number, ref_construction: number, ref_transaction: number, adresse: any, avec_gaz, backoffice_ID?) {
    return this.http.post(this.HOST + '/diagnostics/obligatoires', {
      ref_bien, copro, superficie, ref_construction,
      ref_transaction, adresse, avec_gaz, backoffice_ID
    }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  gestionDisponibilite(action, res?) {
    return this.http.post(this.HOST + '/rendez-vous/disponibilite', { action, ...res }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }


  postCreneaux(code_postal: string, duree_rdv: any, semaine_suivante: number, jours_valides, jours_suivants?: number, backoffice_ID?: number) {
    return this.http.post(this.HOST + '/rendez-vous/creneaux', { code_postal, duree_rdv, semaine_suivante, jours_valides, jours_suivants, backoffice_ID }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  postGestionCreneaux(semaine_suivante: number, creneau?) {
    return this.http.post(this.HOST + '/rendez-vous/gestion-creneaux', { semaine_suivante, creneau }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  gestionJourOuvres(action: string, liste?) {
    return this.http.post(this.HOST + '/rendez-vous/gestion-jours-ouvres', { action, liste }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  postRendezVous(res: any, action: string, origin: string) {
    return this.http.post(this.HOST + '/rendez-vous', { ...res, action, origin }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }).pipe(catchError(this.handleError));
  }

  postErrorLog(res: any) {
    return this.http.post(
      this.HOST + '/log/httpError',
      { ...res },
      {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        responseType: 'text'   // ← ici on précise qu’on veut du texte, pas du JSON
      }
    );
  }

  loginWithGoogle(token: string) {
    const body = { token };
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.post<any>(
      `${this.HOST}/acces-client/google-login`,
      body,
      httpOptions
    );
  }

  modifRendezVous(res: any, ID: number, action: string, origin: string, token?) {
    return this.http.post(this.HOST + '/rendez-vous', { ...res, ID, action, origin, token }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }
  modifTableauTexte(ID: number, res: any, action: string) {
    return this.http.post(this.HOST + '/rendez-vous', { ID, ...res, action }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }
  modifGestionRendezVous(ID: number, res: any, action: string) {
    return this.http.post(this.HOST + '/rendez-vous', { ID, ...res, action }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  functionSimpleGestionRendezVous(action: string) {
    return this.http.post(this.HOST + '/rendez-vous', { action }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }


  modifTableauDateCreneau(ID: number, jour: any, creneau: any, action: string) {
    return this.http.post(this.HOST + '/rendez-vous', { ID, jour, creneau, action }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  modifTableauMenuDeroulant(ID: number, res: any, action: string) {
    return this.http.post(this.HOST + '/rendez-vous/modif_tableau', { ID, res, action }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  setDevisRefuse(rdv_ID: number, valeur: 0 | 1, ref_motif_refus_devis_ID?: number, commentaire_refus_devis?: string) {
    return this.http.post(this.HOST + '/rendez-vous/set-devis-refuse', { rdv_ID, valeur, ref_motif_refus_devis_ID, commentaire_refus_devis }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  getMotifsRefusDevis() {
    return this.http.post(this.HOST + '/refs/motifs-refus-devis', {}, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  getRefusDevisDetail(rdv_ID: number) {
    return this.http.post(this.HOST + '/rendez-vous/refus-devis-detail', { rdv_ID }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  supprimerDateRDV(ID: number, action = 'supprimer_date_rdv') {
    return this.http.post(this.HOST + '/rendez-vous', { ID, action }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  rendezVousSuiviOuModifie(ID: number, action: string) {
    return this.http.post(this.HOST + '/rendez-vous', { ID, action }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  relancerClient(ID: number, action: string) {
    return this.http.post(this.HOST + '/rendez-vous', { ID, action }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }
  relanceGeneralClient(IDs, action: string) {
    return this.http.post(this.HOST + '/rendez-vous', { IDs, action }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  propositionMissionTechnicien(ID, technicien_IDs, action: string) {
    return this.http.post(this.HOST + '/rendez-vous', { ID, technicien_IDs, action }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  relanceImpayesByIds(factures_ids, dates, download = false, groupement = null) {
    let response = download ? 'blob' : 'json';
    return this.http.post(this.HOST + '/impayes/relanceImpayes', { factures_ids, dates, download, groupement }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', })
    })
  }

  relanceImpayeFacture(facture_ID) {
    return this.http.post(this.HOST + '/impayes/relanceImpaye', { facture_ID }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', })
    })
  }

  telechargeresumeByIds(factures_ids, dates, download = true, groupement = null) {
    return this.http.post(this.HOST + '/impayes/relanceImpayes', { factures_ids, dates, download, groupement }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', }), responseType: 'blob'
    })
  }

  relanceGeneralImpayesByIds(liste_a_relancer, dates) {
    return this.http.post(this.HOST + '/impayes/relanceImpayes', { liste_a_relancer, dates }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  getRendezVousAgenda(res) {
    return this.http.post(this.HOST + '/agenda/liste-agenda', { ...res }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  gestionAgendaFunction(action, res?) {
    return this.http.post(this.HOST + '/agenda/gestion-agenda', { ...res, action }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  getEvenement(ID) {
    return this.http.get(this.HOST + '/evenement/' + ID);
  }

  deletEvenement(ID) {
    return this.http.delete(this.HOST + '/evenement/' + ID)
  }

  modifEvenement(ID, res) {
    return this.http.put(this.HOST + '/evenement/' + ID, { ...res }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  ajoutEvenement(res) {
    return this.http.post(this.HOST + '/evenement', { ...res }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  getRendezVous(res: any, offset?, archive = false) {
    return this.http.post(this.HOST + '/rendez-vous/liste' + (offset ? '/' + offset : ''), { ...res, archive }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }



  getReclamations(res: any, offset?, archive = false) {
    return this.http.post(this.HOST + '/reclamation/listeReclamations' + (offset ? '/' + offset : ''), { ...res, archive }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  gestionMessageReclamation(res, action: string) {
    return this.http.post(this.HOST + '/reclamation/gestion-message-client', { ...res, action }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  getRdvPourReclamation(ID: number, lien_txt: string, backoffice_ID?) {
    return this.http.post(this.HOST + '/reclamation/affilie', { ID, lien_txt, backoffice_ID }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  envoyerReclamation(res: any, origin, ID?: number) {
    return this.http.post(this.HOST + '/reclamation/ajout', { ...res, ID, origin }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  modifierReclamation(res: any, ID: number, action: string) {
    return this.http.post(this.HOST + '/reclamation/modification', { ...res, ID, action }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  modifTableauReclamationTexte(ID: number, res: any, action: string) {
    return this.http.post(this.HOST + '/reclamation/modif_tableau', { ID, ...res, action }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  modifTableauReclamationMenuDeroulant(ID: number, res: any, action: string) {
    return this.http.post(this.HOST + '/reclamation/modif_tableau', { ID, res, action }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  gestionReclamation(ID: number, action: string) {
    return this.http.post(this.HOST + '/reclamation/modif_tableau', { ID, action }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  deleteReclamation(ID: number) {
    return this.http.post(this.HOST + '/reclamation/delete', { ID })
  }

  getReclamationRepTechnicien(ID: number, lien_txt: string) {
    return this.http.post(this.HOST + '/reclamation/page-technicien', { ID, lien_txt }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  nouvellePrestation(res: any, action: string) {
    return this.http.post(this.HOST + '/reclamation/prestation', { ...res, action }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }).pipe(catchError(this.handleError));
  }

  envoyerRepTechnicien(res: any, ID: number) {
    return this.http.post(this.HOST + '/reclamation/reponse-technicien', { ...res, ID }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  getListeChequesRemise(res, action) {
    return this.http.post(this.HOST + '/facturation/gesion-remise-cheque', { ...res, action }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  gestionRemiseCheques(res) {
    return this.http.post(this.HOST + '/facturation/gesion-remise-cheque', { ...res }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  getListeRdvSousTraitant(res, action) {
    return this.http.post(this.HOST + '/techniciens/gesion-compta-sous-traitant', { ...res, action }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  gestionRdvSousTraitant(res) {
    return this.http.post(this.HOST + '/techniciens/gesion-compta-sous-traitant', { ...res }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  envoyerRenouvellement(res: any, origin: string, ID?: number) {
    return this.http.post(this.HOST + '/renouvellement/ajout', { ...res, origin, ID }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  getErrors(offset?) {
    return this.http.get(this.HOST + '/log/listeErreurs' + (offset ? '/' + offset : ''));
  }



  deleteErrors(ID: number) {
    return this.http.post(this.HOST + '/log/delete', { ID })
  }

  deleteRendezVous(ID: number, action, origin = 'backoffice', token?) {
    return this.http.post(this.HOST + '/rendez-vous', { ID, action, origin, token })
  }

  restoreRendezVous(ID: number, action) {
    return this.http.post(this.HOST + '/rendez-vous', { ID, action })
  }

  deleteCorbeille(action) {
    return this.http.post(this.HOST + '/rendez-vous', { action, origin: 'backoffice' })
  }

  getClients(res, offset?, no_limit = false) {
    return this.http.post(this.HOST + '/clients/listeClients' + (offset ? '/' + offset : ''), { ...res, no_limit }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  getImpayes(res: any, offset = 0, no_limit = false) {
    return this.http.post(this.HOST + '/impayes/listeImpayes', { ...res, offset, no_limit }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  modifTableauImpayesTexte(res: any, action: string) {
    return this.http.post(this.HOST + '/impayes/modif_tableau', { ...res, action }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  relanceImpayesDOByIds(rdv_IDs: any, action = 'relance_donneur_ordre') {
    return this.http.post(this.HOST + '/impayes/relance_donneur_ordre', { rdv_IDs, action }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  deleteClient(ID: number) {
    return this.http.post(this.HOST + '/clients/delete', { ID })
  }

  ajoutClient(res: any) {
    return this.http.post(this.HOST + '/clients/ajout', { ...res }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  gestionClient(res: any, action) {
    return this.http.post(this.HOST + '/clients/gestion-client', { ...res, action }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }


  gestionMailPresentation(res: any, action) {
    return this.http.post(this.HOST + '/clients/gestion-mail-presentation', { ...res, action }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  modificationClient(res: any, ID: number) {
    return this.http.post(this.HOST + '/clients/modification', { ...res, ID }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  getContactsAgence(res, offset?) {
    return this.http.post(this.HOST + '/acces-client/liste-contacts' + (offset ? '/' + offset : ''), { ...res }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  gestionTechniciens(res: any, action) {
    return this.http.post(this.HOST + '/techniciens/gestion-techniciens', { ...res, action }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }


  getTechniciens(res, offset?) {
    return this.http.post(this.HOST + '/techniciens/listeTechniciens' + (offset ? '/' + offset : ''), { ...res }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  getSousTraitants(res, offset?) {
    return this.http.post(this.HOST + '/techniciens/listeSousTraitants' + (offset ? '/' + offset : ''), { ...res }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  deleteTechnicien(ID: number) {
    return this.http.post(this.HOST + '/techniciens/delete', { ID })
  }

  ajoutTechnicien(res: any) {
    return this.http.post(this.HOST + '/techniciens/ajout', { ...res }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  ajoutSousTraitant(res: any) {
    return this.http.post(this.HOST + '/techniciens/ajoutSousTraitant', { ...res }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  modificationTechnicien(res: any, ID: number) {
    return this.http.post(this.HOST + '/techniciens/modification', { ...res, ID }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  listCertifsTechnicien(TechnicienID: number) {
    return this.http.get(`${this.HOST}/techniciens/certifs?technicien_ID=${TechnicienID}`);
  }

  addCertifsTechnicien(row: any) {
    return this.http.post(`${this.HOST}/techniciens/certifs`, row, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    });
  }

  modifCertifsTechnicien(id: number, row: any) {
    return this.http.put(`${this.HOST}/techniciens/certifs/${id}`, row, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    });
  }

  deleteCertifsTechnicien(id: number) {
    return this.http.delete(`${this.HOST}/techniciens/certifs/${id}`);
  }

  getUtilisateurs(recherche, filter_date_rdv, offset?) {
    return this.http.post(this.HOST + '/utilisateur/listeUtilisateurs' + (offset ? '/' + offset : ''), { recherche, filter_date_rdv }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  deleteUtilisateur(ID: number) {
    return this.http.post(this.HOST + '/utilisateur/delete', { ID })
  }

  invalidateSessions(utilisateur_ID: number) {
    return this.http.post(this.HOST + '/utilisateur/invalidate-sessions', { utilisateur_ID })
  }

  setup2faTotp() {
    return this.http.post(this.HOST + '/utilisateur/twofa-setup-totp', {})
  }

  confirm2faTotp(data: any) {
    return this.http.post(this.HOST + '/utilisateur/twofa-confirm-totp', data)
  }

  disable2fa() {
    return this.http.post(this.HOST + '/utilisateur/twofa-disable', {})
  }

  loginManagement(res: any) {
    return this.http.post(this.HOST + '/utilisateur/login', { ...res }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }), withCredentials: true
    })
  }

  refreshToken() {
    return this.http.post(this.HOST + '/utilisateur/refresh', { utilisateur_ID: localStorage.getItem('utilisateur') }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }), withCredentials: true
    })
  }


  demandeNouveauMdp(mail: string) {
    return this.http.post(this.HOST + '/utilisateur/nouveau-mot-de-passe', { mail }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  resetMotDePasse(res: { token: string, password: string }) {
    return this.http.post(this.HOST + '/utilisateur/nouveau-mot-de-passe', { ...res }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }


  ajoutUtilisateur(res: any) {
    return this.http.post(this.HOST + '/utilisateur/ajout', { ...res }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }


  modificationUtilisateur(res: any, ID: number) {
    return this.http.post(this.HOST + '/utilisateur/modification', { ...res, ID }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  utilisateurInfo: any;
  utilisateurInfos(bloquer: boolean) {
    if (this.utilisateurInfo) {
      console.log('utilisateur depuis le cache');
      return of(this.utilisateurInfo)
    }
    let path = bloquer ? '/utilisateur/info-end' : '/utilisateur/info';
    return this.http.get(this.HOST + path).pipe(map((res: any) => {
      this.utilisateurInfo = res;
      return res;
    }));



  }

  gestionUtilisateur(res, action) {
    return this.http.post(this.HOST + '/utilisateur/gestion', { res, action }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  signatureDevis(ID: number, backoffice_ID: number, token: string, action, res = null) {
    return this.http.post(this.HOST + '/complement-dossier/devis-a-signer', { ID, backoffice_ID, token, action, ...res }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }


  getRdvPourConplementDossier(ID: number, backoffice_ID: number, lien_txt: string) {
    return this.http.post(this.HOST + '/complement-dossier/a-completer', { ID, backoffice_ID, lien_txt }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }



  envoyerComplementDossier(res: any, ID: number, token: string) {
    return this.http.post(this.HOST + '/complement-dossier/completer-dossier', { ...res, ID, token }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  getRdvSatisfactionClient(ID: number, token: string, backoffice_ID: number, action = "get-rdv") {
    return this.http.post(this.HOST + '/complement-dossier/satisfaction-client', { ID, token, backoffice_ID, action }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  envoyerSatisfactionClient(res: any, ID: number, action: string) {
    return this.http.post(this.HOST + '/complement-dossier/satisfaction-client', { ...res, ID, action }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  getRdvPourConfirmation(ID: number, backoffice_ID: number, lien_txt: string) {
    return this.http.post(this.HOST + '/rendez-vous/a-confirmer', { ID, backoffice_ID, lien_txt }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  getRdvPourPropositionMission(ID: number, backoffice_ID: number, technicien_ID: number, token: string) {
    return this.http.post(this.HOST + '/rendez-vous/mission-a-accepter', { ID, backoffice_ID, technicien_ID, token }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  getRdvPourModifClient(backoffice_ID: number, ID: number, token: string) {
    return this.http.post(this.HOST + '/rendez-vous/pour-modif-client', { backoffice_ID, ID, token }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }


  confirmationTechnicienRdv(res: any, ID: number, action?) {
    return this.http.post(this.HOST + '/rendez-vous/confirmation', { ...res, ID, action }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  filigraneRapport(rdv_ID: number) {
    return this.http.post(this.HOST + '/rendez-vous/filigrane-rapport', { rdv_ID }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  EnregistrementTechnicienRdv(res: any, ID: number, action?) {
    return this.http.post(this.HOST + '/rendez-vous/gestion-suivi', { ...res, ID, action }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  duplicationRdv(rdv_ID) {
    return this.http.post(this.HOST + '/rendez-vous/duplication', { rdv_ID }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }
  //Classe pour non admin
  importFile(ID: number, backoffice_ID: number, token: string, uploadData: FormData) {//ok pour recla et paiement
    return this.http.post(this.HOST + '/upload/import/' + backoffice_ID + '/' + ID + '/' + token + '?ngsw-bypass=1', uploadData, {
      observe: 'response', responseType: 'json'
    })
  }

  importFileAdmin(ID: number, uploadData: FormData) {//ok pour recla et paiement
    return this.http.post(this.HOST + '/upload/import/' + ID + '?ngsw-bypass=1', uploadData, {
      observe: 'response', responseType: 'json'
    })
  }

  // Upload direct GCS via URL signée (catégories > 32 Mo). Étape 1/2 : demande l'URL.
  getSignedUploadUrl(body: { ID: number, backoffice_ID: number, token: string, file_categorie_key: string, nom: string, size: number }) {
    return this.http.post(this.HOST + '/upload/signed-url', body, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  // Upload direct GCS via URL signée. Étape 2/2 : confirme et persiste la ligne upload_file.
  confirmSignedUpload(body: { ID: number, backoffice_ID: number, token: string, file_categorie_key: string, path: string, nom: string, tag_ID?: number }) {
    return this.http.post(this.HOST + '/upload/confirm', body, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  // PUT direct vers GCS via URL signée. Le TokenInterceptor ignore les URLs hors HOST,
  // donc aucun header d'auth n'est ajouté (sinon la signature GCS échouerait).
  // `ngsw-bypass` : court-circuite le service worker Angular, qui sinon intercepte la
  // requête, peine à cloner les corps volumineux et renvoie un 504 synthétique.
  putToSignedUrl(signedUrl: string, file: File, contentType: string, lengthRangeHeader: string) {
    return this.http.put(signedUrl, file, {
      headers: new HttpHeaders({
        'Content-Type': contentType,
        'x-goog-content-length-range': lengthRangeHeader
      }),
      reportProgress: true,
      observe: 'events',
    })
  }


  getRapportZip(rdv_ID, backoffice_ID: number, token: any) {
    return this.http.post(this.HOST + '/complement-dossier/rapports', { rdv_ID, backoffice_ID, token }, {
      responseType: 'blob'
    })
  }



  getUploadFiles(res: any) {
    return this.http.post(this.HOST + '/upload/get', { ...res }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  modifUploadFiles(file_ID: number, result) {
    return this.http.put(this.HOST + '/upload' + file_ID, { ...result }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }


  deleteUploadFiles(file_ID: number, token = "", backoffice_ID = 0) {
    return this.http.post(this.HOST + '/upload/delete_file', { file_ID, token, backoffice_ID }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }
  //a supprimer (voir les utilisations)



  chargerInfosPaiement(rendez_vous_ID: number, backoffice_ID: number, hash_token: string, skip_checkout: boolean = false) {
    return this.http.post(this.HOST + '/rendez-vous/infos-paiement', { fid: rendez_vous_ID, backoffice_ID: backoffice_ID, h: hash_token, ...(skip_checkout ? { skip_checkout: true } : {}) });
  }

  envoiPaiementStripe(token: string, data: any, facture_ID: number) {
    return this.http.post(this.HOST + '/paiement/envoi-paiement/stripe', { token, data, facture_ID });
  }

  nouvelleFacture(donneesFacturation) {
    return this.http.post(this.HOST + '/facturation/nouvelle_facture', { ...donneesFacturation }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  getClientsMensualises() {
    return this.http.get(this.HOST + '/facturation/clients-mensualises');
  }

  getConformiteFacturationElectronique() {
    return this.http.get(this.HOST + '/facturation/electronique/conformite');
  }

  getRaccordementFacturationElectronique() {
    return this.http.get(this.HOST + '/facturation/electronique/raccordement');
  }

  raccorderPlateforme(raccordement) {
    return this.http.post(this.HOST + '/facturation/electronique/raccordement', raccordement, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  demarrerOAuthPlateforme(plateforme_ID: number) {
    return this.http.post(this.HOST + '/facturation/electronique/oauth/demarrer', { plateforme_ID });
  }

  terminerOAuthPlateforme(state: string, code: string) {
    return this.http.post(this.HOST + '/facturation/electronique/oauth/retour', { state, code });
  }

  deconnecterPlateforme(raccordement_ID: number) {
    return this.http.post(this.HOST + '/facturation/electronique/deconnexion', { raccordement_ID });
  }

  activerFacturationElectronique(actif: boolean) {
    return this.http.post(this.HOST + '/facturation/electronique/activation', { actif }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  getDateDerniereFacture() {
    return this.http.get(this.HOST + '/facturation/date-derniere-facture');
  }

  getMissionsNonFacturees(compte_client_ID: number) {
    return this.http.get(this.HOST + '/facturation/missions-non-facturees?compte_client_ID=' + compte_client_ID);
  }

  createFactureGroupee(donneesFacturation) {
    return this.http.post(this.HOST + '/facturation/facture-groupee', { ...donneesFacturation }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    });
  }

  envoyerAvoir(FactureID, montant, avec_envoi) {
    return this.http.post(this.HOST + '/facturation/envoyer/avoir', { FactureID, montant, avec_envoi }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    });
  }

  getListeAvoirs(FactureID = null, filter_date = null) {
    return this.http.post(this.HOST + '/facturation/liste-avoirs', { FactureID, filter_date }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    });
  }

  facturesGroupees(res: any, action) {
    return this.http.post(this.HOST + '/facturation/factures-groupees', { ...res, action }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    });
  }

  getRendezVousClient(res: any, offset?) {
    return this.http.post(this.HOST + '/acces-client/liste-rdv' + (offset ? '/' + offset : ''), { ...res }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  modificationInfosClient(res: any, mail_id, backoffice_ID) {
    return this.http.post(this.HOST + '/acces-client/modifier-infos', { ...res, mail_id, backoffice_ID }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  notifierParEmailPriseRendezVous(res) {
    return this.http.post(this.HOST + '/rendez-vous/notifier-rdv-en-cours', { ...res }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  demandeDeRappel(res) {
    return this.http.post(this.HOST + '/rendez-vous/demande-de-rappel', { ...res }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  getClientInfos(backoffice_ID,disconnect=true) {
    return this.http.post(this.HOST + '/acces-client/infoclient', { backoffice_ID,disconnect }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    });
  }

  getListeBackoffices() {
    return this.http.get(this.HOST + '/acces-client/listeBackoffices');
  }


  downloadFactures(IDs, client_ID,backoffice_ID): any {
    return this.http.post(this.HOST + '/acces-client/telecharger-facture', { IDs, client_ID,backoffice_ID }, {
      responseType: 'blob'
    });
  }

  NouveauMdpClient(mail: string) {
    return this.http.post(this.HOST + '/acces-client/newpassword', { mail }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  loginClient(res: any) {
    return this.http.post(this.HOST + '/acces-client/login', { ...res }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  logoutClient() {
    return this.http.post(this.HOST + '/acces-client/logout', {})
  }



  gestionPrix(res: any, cas: string) {
    return this.http.post(this.HOST + '/diagnostics/gestion-prix', { ...res, cas }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  listCodePromo(recherche_general, action = "liste") {
    return this.http.post(this.HOST + '/diagnostics/gestion-code-promo', { recherche_general, action }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  supprimerCode(ID: any, action = "delete") {
    return this.http.post(this.HOST + '/diagnostics/gestion-code-promo', { ID, action }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  modifCodePromo(ID: any, res: any, action = "modif") {
    return this.http.post(this.HOST + '/diagnostics/gestion-code-promo', { ID, ...res, action }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  ajoutCodePromo(res: any, action = "ajout") {
    return this.http.post(this.HOST + '/diagnostics/gestion-code-promo', { ...res, action }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  listTag(ref_type_tag_ID: number) {
    return this.http.get(this.HOST + '/tag/' + ref_type_tag_ID)
  }

  supprimerTag(tag_ID) {
    return this.http.delete(this.HOST + '/tag/' + tag_ID)
  }

  appliquerTagUpload(tag_ID: number, file_ID: number, admin: boolean, ref_type_tag_ID: number) {
    return this.http.post(this.HOST + '/tag/set-upload', { tag_ID, file_ID, admin, ref_type_tag_ID }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  modifTag(tag_ID: any, res: any) {
    return this.http.post(this.HOST + '/tag/' + tag_ID, { ...res }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  ajoutTag(res: any) {
    return this.http.post(this.HOST + '/tag', { ...res }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  // ── GRILLE PAR FORMULE ─────────────────────────────────────────── début ────
  getGrilleFormule() {
    return this.http.get(this.HOST + '/grille-formule');
  }

  saveGrilleFormule(type: string, config: any) {
    return this.http.post(this.HOST + '/grille-formule', { type, config });
  }

  deleteGrilleFormule() {
    return this.http.delete(this.HOST + '/grille-formule');
  }

  postGenerateGrille(notes: string, file?: File) {
    const formData = new FormData();
    formData.append('notes', notes);
    if (file) formData.append('grille_file', file, file.name);
    return this.http.post(this.HOST + '/ai/generate-grille', formData)
      .pipe(catchError(this.handleError));
  }

  postSaveGeneratedGrille(rows: any[], grille_type: 'pack' | 'formule' = 'pack') {
    return this.http.post(this.HOST + '/ai/generate-grille', { save: 1, rows, grille_type }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }).pipe(catchError(this.handleError));
  }
  // ── GRILLE PAR FORMULE ───────────────────────────────────────────── fin ────

  listLigneGrille() {
    return this.http.get(this.HOST + '/grille-pack')
  }

  getGrillePackConfig() {
    return this.http.get(this.HOST + '/grille-pack/config');
  }

  getGrillePdf() {
    return this.http.get(this.HOST + '/grille-pack/grille_pdf');
  }

  DeleteLigneGrille(ID) {
    return this.http.delete(this.HOST + '/grille-pack/' + ID)
  }


  modifLigneGrille(ID: any, res: any) {
    return this.http.put(this.HOST + '/grille-pack/' + ID, { ...res }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  ajoutLigneGrille(res: any) {
    return this.http.post(this.HOST + '/grille-pack', { ...res }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  listSupplements() {
    return this.http.get(`${this.HOST}/supplements_regionaux`);
  }

  addSupplement(row: any) {
    return this.http.post(`${this.HOST}/supplements_regionaux`, row, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    });
  }

  modifSupplement(id: number, row: any) {
    return this.http.put(`${this.HOST}/supplements_regionaux/${id}`, row, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    });
  }

  deleteSupplement(id: number) {
    return this.http.delete(`${this.HOST}/supplements_regionaux/${id}`);
  }

  mailMissionTechnicien(rdv_id: any) {
    return this.http.post(this.HOST + '/rendez-vous/mail-technicien', { rdv_id }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  sendSMS(res: any) {
    return this.http.post(this.HOST + '/sms/send', { ...res }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }


  sendMail(uploadData: any) {//ok pour recla et paiement
    return this.http.post(this.HOST + '/sms/mail', uploadData, {
      reportProgress: true, observe: 'response', responseType: 'json'
    })
  }

  getSmsModeles() {
    return this.http.get(this.HOST + '/sms/modeles')
  }


  ModeleSms(ID: number, cas: string, message: string) {
    return this.http.post(this.HOST + '/sms/gestion', { ID, cas, message }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  gestionModelReclamation(action: string, ID?: number, message?: string) {
    return this.http.post(this.HOST + '/reclamation/gestion-model', { ID, action, message }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  getInfoClient(mail_id) {
    return this.http.post(this.HOST + '/clients/infos', { mail_id }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  /**
   * SIRET du compte client portant cet e-mail, retrouvé comme l'API le fait à l'émission de la facture.
   * Back-office connecté uniquement (la route exige une session).
   */
  siretCompteClient(mail_id: string): Observable<string | null> {
    return this.getInfoClient(mail_id).pipe(map((compte: any) => compte?.siret || null));
  }

  getInfoContact(tel: any, action = "get_info") {
    return this.http.post(this.HOST + '/clients/gestion-contact', { tel, action }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  supprimerContact(ID: any, action = "delete") {
    return this.http.post(this.HOST + '/clients/gestion-contact', { ID, action }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  modifContact(ID: any, res: any, action = "modif") {
    return this.http.post(this.HOST + '/clients/gestion-contact', { ID, ...res, action }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  listContact(ID: any, filter: any, offset, action = "liste") {
    return this.http.post(this.HOST + '/clients/gestion-contact', { ID, ...filter, offset, action }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  ajoutContact(res: any, action = "ajout") {
    return this.http.post(this.HOST + '/clients/gestion-contact', { ...res, action }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  supprimerDemarcheClient(ID: any, action = "delete") {
    return this.http.post(this.HOST + '/clients/gestion-demarchage', { ID, action }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  modifDemarcheClient(ID: any, res: any, action = "modif") {
    return this.http.post(this.HOST + '/clients/gestion-demarchage', { ID, ...res, action }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  listDemarcheClient(compte_client_ID: any, recherche_general, offset, action = "liste") {
    return this.http.post(this.HOST + '/clients/gestion-demarchage', { compte_client_ID, recherche_general, offset, action }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  ajoutDemarcheClient(res: any, action = "ajout") {
    return this.http.post(this.HOST + '/clients/gestion-demarchage', { ...res, action }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }
  supprimerDemarcheClientImpayés(ID: any, action = "delete") {
    return this.http.post(this.HOST + '/impayes/gestion-demarchage', { ID, action }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  modifDemarcheClientImpayés(ID: any, res: any, action = "modif") {
    return this.http.post(this.HOST + '/impayes/gestion-demarchage', { ID, ...res, action }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  listDemarcheClientImpayés(mail_ID: any, recherche_general, offset, action = "liste") {
    return this.http.post(this.HOST + '/impayes/gestion-demarchage', { mail_ID, recherche_general, offset, action }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  ajoutDemarcheClientImpayés(res: any, action = "ajout") {
    return this.http.post(this.HOST + '/impayes/gestion-demarchage', { ...res, action }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }


  getContactsDemarchage(res, offset?, no_limit = false) {
    return this.http.post(this.HOST + '/demarchage/listeContacts' + (offset ? '/' + offset : ''), { ...res, no_limit }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }
  modificationContactDemarchage(res: any, ID: number) {
    return this.http.post(this.HOST + '/demarchage/modification', { ...res, ID }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  gestionContactDemarchage(ID: number, action) {
    return this.http.post(this.HOST + '/demarchage/gestion', { ID, action })
  }

  ajoutContactDemarchage(res: any) {
    return this.http.post(this.HOST + '/demarchage/ajout', { ...res }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  //relance demarchage
  modifTableauDate(ID: number, jour: any, action: string) {
    return this.http.post(this.HOST + '/demarchage/gestion', { ID, jour, action }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  gestionDepartements(res: any, cas) {
    return this.http.post(this.HOST + '/diagnostics/gestion-departements', { ...res, cas }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  getFactures(filter, no_limit) {
    return this.http.post(this.HOST + '/facturation/liste_factures', { ...filter, no_limit }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  createExportFacturesMois(month: number, year: number) {
    return this.http.post(this.HOST + '/facturation/export-factures-mois/create', { month, year }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  listExportFacturesMois(limit = 12) {
    return this.http.post(this.HOST + '/facturation/export-factures-mois/list', { limit }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  envoiPaiement(res, facture_ID) {
    return this.http.post(this.HOST + '/paiement/gestion-paiement', { ...res, facture_ID, situation: "nouveau" }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }
  envoiPaiementNonAdmin(res, facture_ID, backoffice_ID, rdv_ID, token) {
    return this.http.post(this.HOST + '/paiement/gestion-paiement', { ...res, facture_ID, backoffice_ID, rdv_ID, token, situation: "nouveau" }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  listePaiements(facture_ID, backoffice_ID?, rdv_ID?, token?) {
    return this.http.post(this.HOST + '/paiement/gestion-paiement', { facture_ID, backoffice_ID, rdv_ID, token, situation: "liste-paiements" }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  deletePaiement(facture_ID: number, paiement_ID: number, backoffice_ID?, rdv_ID?, token?) {
    return this.http.post(this.HOST + '/paiement/gestion-paiement', { facture_ID, paiement_ID, backoffice_ID, rdv_ID, token, situation: 'delete' }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }
  checkPassword(password: string) {
    let msg: any;
    // let strongRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d).{8,}$/;
    let strongRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*\W).{8,}$/;
    let mediumRegex = /^(?=.*[A-Za-z])(?=.*\d).{8,}$/;
    let enoughRegex = /^(?=.{8,})/;

    if (password.length === 0) {
      msg = { valid: false, msg: 'Entrez un mot de passe' };
    } else if (!enoughRegex.test(password)) {
      msg = { valid: false, msg: 'Longueur insuffisante (8 caractères minimum)' };
    } else if (strongRegex.test(password)) {
      msg = { valid: true, msg: 'Fort' };
    } else if (mediumRegex.test(password)) {
      msg = { valid: true, msg: 'Moyen' };
    } else {
      msg = { valid: false, msg: 'Faible' };
    }

    return msg;
  }


  relancesAuto(situation: string, rel: any, delai: number = 0, relance_devis = false) {
    return this.http.post(this.HOST + '/relances/gestion', { situation, params: rel, delai_relance: delai, relance_devis: relance_devis }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  relanceDevisManuelle(rdv_ID: number) {
    return this.http.post(this.HOST + '/relances/relance-devis', { rdv_ID }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  mailHistory(date?: string, page: number = 0, email?: string, dossier?: number, dossierDate?: string) {
    let params = `?page=${page}`;
    if (date) params += `&date=${date}`;
    if (email) params += `&email=${encodeURIComponent(email)}`;
    if (dossier) params += `&dossier=${dossier}`;
    if (dossierDate) params += `&dossierDate=${encodeURIComponent(dossierDate)}`;
    return this.http.get(this.HOST + '/mail/mail-history' + params)
  }

  mailDetails(messageId: string, email?: string) {
    let url = this.HOST + `/mail/mail-details?messageId=${encodeURIComponent(messageId)}`;
    if (email) url += `&email=${encodeURIComponent(email)}`;
    return this.http.get(url);
  }

  smsHistory(date?: string, tel?: string) {
    let params = '';
    if (date) params += `?date=${date}`;
    if (tel) params += `${params ? '&' : '?'}tel=${encodeURIComponent(tel)}`;
    return this.http.get(this.HOST + '/sms/sms-history' + params)
  }

  getPaiements(filtre: any) {
    return this.http.post(this.HOST + '/facturation/liste_paiements', { ...filtre }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }


  //admin
  chargerInfosPaiementAdmin(admin_facture_ID: number, hash_token: string) {
    return this.http.post(this.HOST + '/gestion/infos-paiement', { admin_facture_ID, hash_token }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  nouvelErp(res: any) {
    return this.http.post(this.HOST + '/adresse/erp', { ...res }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  renewErp(ID: number) {
    return this.http.put(this.HOST + '/adresse/erp', { ID }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  // Génère un ERP ERNMT rattaché à un rendez-vous (remplit rdv.erp_link).
  nouvelErpRdv(res: any) {
    return this.http.post(this.HOST + '/adresse/erp-rdv', { ...res }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  listErp(urlParams: any) {
    return this.http.get(this.HOST + '/adresse/erp?' + new URLSearchParams(urlParams).toString())
  }


  SearchVille(cp: string) {
    return this.http.get(this.HOST + '/adresse/ville/' + cp)
  }

  rechargeCredit(rechargeValue: number) {
    return this.http.post(this.HOST + '/gestion/recharge', { choix_credit: rechargeValue }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  getCredits() {
    return this.http.get(this.HOST + '/gestion/recharge')
  }

  achatErp(data: any) {
    return this.http.post(this.HOST + '/acces-client/achat-erp', { ...data }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  gdQuizzJeton() {
    return this.http.post<{ error: boolean; data: { jeton: string } }>(this.HOST + '/quizz/jeton', {});
  }

  // --- Environot (prestataire ERP alternatif, mode iframe) ---
  environotToken(rdv_ID = 0) {
    return this.http.post(this.HOST + '/adresse/environot/token', { rdv_ID }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  environotConnect(login: string, password: string) {
    return this.http.post(this.HOST + '/adresse/environot/connect', { login, password }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  environotCheck() {
    return this.http.get(this.HOST + '/adresse/environot/check')
  }

  // Vérifie l'état de l'ERP Environot d'un rdv : { etat: 'pret'|'en_cours'|'aucune_commande'|'inconnu', erp_link? }.
  // Lecture BDD d'abord (erp_link), puis appel Environot seulement si absent.
  environotVerifierCommande(rdv_ID: number) {
    return this.http.get(this.HOST + '/adresse/environot/verifier-commande?rdv_ID=' + rdv_ID)
  }

  adresseComplete(adresse: string, code_postal: string) {
    adresse = encodeURIComponent(adresse);
    return this.http.get('https://data.geopf.fr/geocodage/search/?q=' + adresse + (code_postal ? '&postcode=' + code_postal : ''));
  }

  askForDelete() {
    return this.http.delete(this.HOST + '/gestion/delete-account');
  }

  sendSmsAvis(filters: any) {
    return this.http.post(this.HOST + '/sms/avis', { ...filters }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  createOrderViva(res: any) {
    return this.http.post(this.HOST + '/paiement/viva/create-order', { ...res }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  // Statut d'impayé de l'abonnement CRM (affichage bandeau backoffice)
  getAbonnementImpaye() {
    return this.http.get(this.HOST + '/paiement/subscription/impaye');
  }

  // Ouvre le Billing Portal Stripe dans un nouvel onglet. Le lien est généré à la
  // demande côté back. L'onglet est ouvert (vide) immédiatement au clic pour éviter
  // le blocage des popups, puis redirigé vers le portail au retour du back.
  ouvrirPortailFacturation() {
    const tab = window.open('', '_blank');
    this.http.get(this.HOST + '/paiement/subscription/portal').subscribe((res: any) => {
      const url = res?.data?.url;
      if (url && tab) { tab.location.href = url; }
      else if (tab) { tab.close(); }
    });
  }

  getStancerStatus() {
    return this.http.get(this.HOST + '/paiement/stancer/status');
  }

  activateStancer() {
    return this.http.post(this.HOST + '/paiement/stancer/activate', {});
  }

  createStancerPayment(fid: number, backoffice_ID: number, h: string) {
    return this.http.post(this.HOST + '/paiement/stancer/checkout', { fid, backoffice_ID, h });
  }

  stancerOnboarding(data: { legal_name: string; first_name: string; last_name: string; email: string; phone: string; country: string }) {
    return this.http.post(this.HOST + '/paiement/stancer/onboarding', data);
  }

  refreshStancer() {
    return this.http.post(this.HOST + '/paiement/stancer/refresh', {});
  }

  saveStancerCredentials(api_key: string) {
    return this.http.post(this.HOST + '/paiement/stancer/credentials', { api_key });
  }

  // Stripe Connect
  getStripeConnectStatus() {
    return this.http.get(this.HOST + '/paiement/stripe-connect/status');
  }

  stripeConnectOnboarding(return_url: string, refresh_url: string) {
    return this.http.post(this.HOST + '/paiement/stripe-connect/onboarding', { return_url, refresh_url }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  activateStripeConnect() {
    return this.http.post(this.HOST + '/paiement/stripe-connect/activate', {}, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  disconnectStripeConnect() {
    return this.http.post(this.HOST + '/paiement/stripe-connect/disconnect', {}, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  resetPasswordClient(res: any) {
    return this.http.post(this.HOST + '/acces-client/password-reset', { ...res }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  getAdresses(jour: string) {
    return this.http.post(this.HOST + '/adresse/liste', { jour }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  getEvenementsParJour(jours: string[]) {
    return this.http.post(this.HOST + '/evenement/liste-par-jour', { jours }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  majCoordonneesBatch(items: { ID: number, coordonnees: [number, number] }[]) {
    return this.http.post(this.HOST + '/rendez-vous', { action: 'maj_coordonnees_batch', items }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }


  listProduits() {
    return this.http.get(this.HOST + '/produits');
  }

  addProduits(produit: ProduitType) {
    return this.http.post(this.HOST + '/produits', { ...produit }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  updateProduits(produit: any) {
    return this.http.put(this.HOST + '/produits', { ...produit }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  deleteProduit(ID: number) {
    return this.http.delete(this.HOST + '/produits/' + ID);
  }

  searchProduct(query: string) {
    return this.http.get(this.HOST + '/produits?query=' + encodeURIComponent(query));
  }

  updateDossierComplexe(dossiers: BienType[], rdv_ID: number, prix: number) {
    return this.http.put(this.HOST + '/dossier', { dossiers, rdv_ID, prix }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  getCalendarAcl(technicien_ID: number) {
    return this.http.get(this.HOST + '/techniciens/liste-calendar/' + technicien_ID);
  }


  getListeElia(res, offset?, no_limit = false) {
    return this.http.post(this.HOST + '/elia/liste-calls' + (offset ? '/' + offset : ''), { ...res, no_limit }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  savePushSubscription(subscriptionData: any) {
    return this.http.post(this.HOST + '/notif-push/save-subscription', subscriptionData);
  }

  // Récupérer les subscriptions pour l'utilisateur courant
  getPushSubscriptions(utilisateurId: number, backofficeId: number) {
    return this.http.get(`${this.HOST}/notif-push/list-subscriptions?userId=${utilisateurId}&backofficeId=${backofficeId}`);
  }

  // Supprimer une subscription par son id en base
  deletePushSubscriptionById(id: number) {
    return this.http.delete(
      `${this.HOST}/notif-push/delete-subscription?id=${id}`
    );
  }


  getNotificationSettings() {
    return this.http.get<{ [key: string]: number }>(`${this.HOST}/notif-push/notifications?action=get_notifications`);
  }

  updateNotificationSetting(data: any[]) {
    return this.http.post(this.HOST + '/notif-push/notifications', { data }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }



  modifStatutElia(ID) {
    return this.http.post(this.HOST + '/elia/modif-statut', { ID }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  importClients(clients: any[]) {
    return this.http.post(this.HOST + '/clients/import', { clients }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    })
  }

  postMagicDiagText(text: string) {
    return this.http.post(this.HOST + '/ai/magic-diag', { text }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }).pipe(catchError(this.handleError));
  }

  postMagicDiagFile(file: File) {
    const formData = new FormData();
    formData.append('magic_diag', file, file.name);
    return this.http.post(this.HOST + '/ai/magic-diag', formData)
      .pipe(catchError(this.handleError));
  }

  postMagicDiagAudio(blob: Blob, filename: string) {
    const formData = new FormData();
    formData.append('magic_diag', blob, filename);
    return this.http.post(this.HOST + '/ai/magic-diag', formData)
      .pipe(catchError(this.handleError));
  }

  getRefsExportAll() {
    return this.http.get(this.HOST + '/refs/export-all');
  }
  getProduitsInternalConfig() {
    return this.http.get(this.HOST + '/produits/internal-config');
  }
  getGrillePackAlgoPricing() {
    return this.http.get(this.HOST + '/grille-pack/algo-pricing');
  }
  getPdfTemplatesExport() {
    return this.http.get(this.HOST + '/pdf/templates-export');
  }
  getMailTemplatesExport() {
    return this.http.get(this.HOST + '/mail/templates-export');
  }
  getGestionFeaturesConfig() {
    return this.http.get(this.HOST + '/gestion/features-config');
  }

  postAnalyseDdt(text: string, mode: string = 'resume', file_id?: number, backoffice_ID?: number) {
    const body: any = { text, mode };
    if (file_id) body.file_id = file_id;
    if (backoffice_ID) body.backoffice_ID = backoffice_ID;
    return this.http.post(this.HOST + '/ai/analyse-ddt', body, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }).pipe(catchError(this.handleError));
  }

}
